import { Carousel, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import { CloudinaryImageV2 } from '../../../../../components/CSCloudinaryAsset/Image';
import type { FixCard, BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface InYourFixSectionProps {
  data: BrandsValuePageData['inYourFix'];
}
const FixExampleCard = ({
  card
}: {
  card: FixCard;
}) => <article className={styles.card}>
    <Text as="h3" className={styles.cardTitle} setting="title-medium">
      {card.title}
    </Text>

    <div className={styles.imageStage}>
      <div className={styles.primaryImageFrame}>
        <CloudinaryImageV2 alt={card.primaryAlt} cloudinaryAsset={card.primaryCloudinaryAsset} sizes={[{
        minWidth: 0,
        staticWidth: 205
      }]} imageProps={{
        className: styles.fixImage,
        loading: 'lazy',
        style: {
          height: '100%',
          objectFit: 'cover'
        }
      }} />
      </div>
      <div className={styles.secondaryImageFrame}>
        <CloudinaryImageV2 alt={card.secondaryAlt} cloudinaryAsset={card.secondaryCloudinaryAsset} sizes={[{
        minWidth: 0,
        staticWidth: 135
      }]} imageProps={{
        className: styles.fixImage,
        loading: 'lazy',
        style: {
          height: '100%',
          objectFit: 'cover'
        }
      }} />
      </div>
    </div>

    <div className={styles.meta}>
      <CloudinaryImageV2 alt={card.avatarAlt} cloudinaryAsset={card.avatarCloudinaryAsset} sizes={[{
      minWidth: 0,
      staticWidth: 34
    }]} imageProps={{
      className: styles.avatar,
      loading: 'lazy',
      style: {
        height: '2.125rem',
        objectFit: 'cover',
        width: '2.125rem'
      }
    }} />
      <Text as="p" className={styles.stylist} setting="body-small-fixed">
        Styled by {card.stylist}
      </Text>
    </div>

    <Text as="p" className={styles.budget} setting="body-small">
      <span className={styles.budgetLabel}>Budget:</span> {card.budget}
    </Text>
    <Text as="p" className={styles.cardDescription} setting="body-small">
      {card.description}
    </Text>
  </article>;
export const InYourFixSection = ({
  data
}: InYourFixSectionProps) => {
  return <section className={styles.section}>
      <ResponsiveSection width="full-bleed" gutter="none">
        <div className={styles.container}>
          <Text as="p" className={styles.eyebrow} setting="eyebrow-medium">
            {data.eyebrow}
          </Text>
          <Text as="h2" className={styles.title} setting="display-large">
            {data.title}
          </Text>
          <Text as="p" className={styles.description} setting="body-medium">
            {data.description}
          </Text>

          <div className={styles.carousel}>
            <Carousel ariaLabel="Example Fixes carousel" slideWidth="309px" gutterOverflow={{
            sm: 1,
            lg: 0
          }} controlsOffsetTop={{
            sm: '10rem'
          }}>
              {data.cards.map(card => <FixExampleCard card={card} key={card.id} />)}
            </Carousel>
          </div>
        </div>
      </ResponsiveSection>
    </section>;
};